// src/App.js
// ==================== Imports ====================
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// ==================== Pages ====================
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProductPage from './pages/Dashboard/Productpage';
import ProductDetails from './pages/Dashboard/ProductDetails';
import UserRequestsData from './pages/Dashboard/UserRequestsData';
import Myaccount from './pages/Myaccount';            // <-- ADDED
import Aboutus from './pages/Aboutus';
import Contactus from './pages/Contactus';
import Categories from "./pages/Categories";


// ==================== Components ====================
import Navbar from './Navbar';
import Footer from "./Footer";




// ==================== App Component ====================
function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<ProductPage />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/requests" element={<UserRequestsData />} />
        <Route path="/myaccount" element={<Myaccount />} />  
        <Route path="/categories" element={<Categories />} />

      </Routes>

      {/* Footer on ALL pages */}
      <Footer />
    </Router>
  );
}

export default App;
